export default __webpack_public_path__ + "static/hearth-a67733b4d59f6b36e6949ea0d3bf2948.png";